var React = require('react');

function LevelBronzeInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(-824.635 -932.755)"},[React.createElement("path",{"d":"M879,973.574a8.342,8.342,0,0,1-4.182,7.231l-18.84,10.838a8.34,8.34,0,0,1-8.322,0L828.817,980.8a8.342,8.342,0,0,1-4.182-7.231v-21.63a8.344,8.344,0,0,1,4.182-7.231l18.84-10.838a8.345,8.345,0,0,1,8.322,0L874.82,944.7A8.344,8.344,0,0,1,879,951.936Z","fill":"#c69689","key":0}),React.createElement("path",{"d":"M856.538,968.946h2.692l2.055-13.016-5.417,4.309-5.167-7.182-5.167,7.182-5.417-4.309,2.055,13.016H852.18","transform":"translate(1.118 1.203)","fill":"none","stroke":"#fff","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2","key":1})]));
}

LevelBronzeInline.defaultProps = {"width":"54.367","height":"60","viewBox":"0 0 54.367 60"};

module.exports = LevelBronzeInline;

LevelBronzeInline.default = LevelBronzeInline;
